<template>
  <v-layout>
    <v-flex xs6>
      <!-- <h3>Metadata Fields</h3> -->
      <v-form v-if="form.metadata">
        <!-- <content-field
          label="Form Title"
          required
          v-model="form.metadata.name"
        ></content-field> -->
        <v-btn
          color="primary"
          class="mb-5"
          @click="addNewField"
        >
          Add new form field
        </v-btn>

        <div v-for="(field, i) in form.fields" :key="field.metadata.id">
          <v-divider v-if="isFieldTypeArray(field)" class="mb-5 mt-5"/>
          <FieldConstructor
            class="mb-2 elevation-5"
            :validation="$v.form.fields.$each[i]"
            :field="field"
            @fieldChange="setNewFieldData($event, i)"
            @changeOrder="changeRow($event, i)"
            @updateFieldValidator="updateFieldValidator"
            @toggleDelete="toggleDelete"
          />

          <div v-if="isFieldTypeArray(field)">
            <v-card class="mt-3 pr-3 pl-3 pb-3 pt-3 elevation-5">
              <h3>{{field.layout.property}} Fields</h3>
              <div v-if="hasValidationData(field)">
                <content-field
                  label="amountLabel"
                  required
                  v-model="field.layout.validators[0].data.max"
                />
              </div>
              <v-btn class="mb-3" @click=addNewInnerField(field.metadata.id)>
                Add new {{field.layout.property}} field
              </v-btn>
              <FieldConstructor
                class="mb-2 elevation-5 innerItem"
                v-for="(fieldChild, j) in field.layout.fields"
                :key="fieldChild.metadata.id"
                :field="fieldChild"
                :validation="$v.form.fields.$each[i].layout.fields.$each[j]"
                @fieldChange="setNewFieldData($event, i, j)"
                @changeOrder="changeRow($event, i, j)"
                @updateFieldValidator="updateFieldValidator"
                @toggleDelete="toggleDelete"
              />
            </v-card>
            <v-divider class="mb-5 mt-5"/>
          </div>
        </div>
        <v-btn
          color="success"
          @click.stop="updateFormData"
        >
          Update Form
        </v-btn>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import FieldConstructor from '@/components/shared/EvFieldConstructor'
  import { path, map, trim, split, assocPath, isNil, clone, isEmpty, lensPath, over } from 'ramda'
  import lodash from 'lodash'
  import debounce from 'lodash.debounce'
  import { required } from 'vuelidate/lib/validators'
  import uuidv4 from 'uuid/v4'

  export default {
    name: 'FormConstructor',
    components: {
      FieldConstructor
    },
    data () {
      return {
        form: {},
        draggable: []
      }
    },
    computed: {
      ...mapGetters(['currentForm'])
    },
    watch: {
      currentForm: {
        handler (newForm) {
          if (!isEmpty(newForm)) {
            this.form = clone(this.currentForm)
          }
        },
        immediate: true
      }
    },
    methods: {
      path,
      ...mapActions(['getFormByType', 'updateForm', 'showResultErrorMessage']),
      isFieldTypeArray (field) {
        return field.layout.type === 'array'
      },
      hasValidationData: path(['layout', 'validators', 0, 'data']),
      updateFieldValidator (val) {
        const addValidatorsToFields = field => {
          return field.metadata.id === val.id
            ? { ...field, layout: { validators: val.validators } }
            : field
        }

        this.form.fields = this.form.fields.map(addValidatorsToFields)
      },
      toggleDelete (id) {
        this.form.fields.forEach(field => {
          if (field.metadata.id === id) {
            field.metadata.delete = !field.metadata.delete
          }
          if (field.layout.type === 'array') {
            field.layout.fields.forEach(innerField => {
              if (innerField.metadata.id === id) {
                innerField.metadata.delete = !innerField.metadata.delete
              }
            })
          }
        })
      },
      addNewField () {
        let newField =
          this.form.fields.push(
            {
              layout: {
                validators: []
              },
              metadata: {
                id: uuidv4()
              }
            }
          )
        window.scrollTo(0, document.body.scrollHeight)
      },
      addNewInnerField (id) {
        this.form.fields.forEach(field => {
          if (field.metadata.id === id) {
            field.layout.fields = [...field.layout.fields,
              {
                layout: {
                  type: 'string',
                  validators: []
                },
                metadata: {
                  id: uuidv4()
                }
              }
            ]
          }
        })
        this.form.fields = [...this.form.fields]
      },
      setNewFieldData (field, fieldNumber, childFieldNumber) {
        let path = isNil(childFieldNumber) ? ['fields', fieldNumber] : ['fields', fieldNumber, 'layout', 'fields', childFieldNumber]
        this.form = assocPath(path, field, this.form)
      },
      //added 2 seconds delay for checking row function FE-2397
      changeRow : debounce(async function ([row, column], parentIndex, childIndex) {
        if (row && column && this.form.hasOwnProperty('fields')) {
          function checkReiterationOrder (fields, index) {
            return fields.find((field, i) => field.layout.row === row && field.layout.column === column && index !== i)
          }

          function sortLodash (fields) {
            return lodash.sortBy(fields, path(['layout', 'row']), path(['layout', 'column']))
          }

          if (typeof childIndex !== 'undefined') {
            const layoutFieldsPath = [parentIndex, 'layout', 'fields']
            this.form.fields = over(lensPath(layoutFieldsPath), sortLodash, this.form.fields)
            if (typeof checkReiterationOrder(path(layoutFieldsPath, this.form.fields), childIndex) !== 'undefined') {
              this.showResultErrorMessage(`You have already had these row and column`)
            }
          } else {
            const oldFields = [...this.form.fields]
            this.form.fields = sortLodash(oldFields)
            if (typeof checkReiterationOrder(oldFields, parentIndex) !== 'undefined') {
              this.showResultErrorMessage(`You have already had these row and column`)
            }
          }
        }
      }, 2000),
      iterateAndCheckAllFields (fields) {
        fields.forEach((field) => {
          if (field.layout.type === 'array') {
            field.layout.fields = field.layout.fields.filter(innerField => {
              return innerField.metadata.delete !== true
            })
          }

          if (field.layout.defaultValue) {
            field.layout.defaultValue = trim(field.layout.defaultValue)
          }
          if (field.layout.values && typeof field.layout.values === 'string') {
            field.layout.values = map(trim, split(',', field.layout.values))
          }

          delete field.metadata.delete
          if (field.layout.type === 'array') {
            field.layout.fields.forEach((innerField) => {
              delete innerField.metadata.delete
            })
          }
          if (field.layout.fields) {
            this.iterateAndCheckAllFields(field.layout.fields)
          }
        })
      },
      updateFormData () {
        this.$v.$touch()
        if (this.$v.$invalid) return
        this.form.fields = this.form.fields.filter(field => {
          return field.metadata.delete !== true
        })
        this.iterateAndCheckAllFields(this.form.fields)
        // this.form.fields.forEach((field) => {
        //   if (field.layout.type === 'array') {
        //     field.layout.fields = field.layout.fields.filter(innerField => {
        //       return innerField.metadata.delete !== true
        //     })
        //   }
        //
        //   if (field.layout.defaultValue) {
        //     field.layout.defaultValue = trim(field.layout.defaultValue)
        //   }
        //   if (field.layout.values && typeof field.layout.values === 'string') {
        //     // console.log('here');
        //     field.layout.values = map(trim, split(',', field.layout.values))
        //   }
        //
        //   delete field.metadata.delete
        //   if (field.layout.type === 'array') {
        //     field.layout.fields.forEach((innerField) => {
        //       delete innerField.metadata.delete
        //     })
        //   }
        // })
        this.updateForm({ fields: this.form.fields })
      }
    },
    validations: {
      form: {
        fields: {
          $each: {
            layout: {
              type: { required },
              width: { required },
              column: { required },
              row: { required },
              property: { required },
              fields: {
                $each: {
                  layout: {
                    type: { required },
                    width: { required },
                    column: { required },
                    row: { required },
                    property: { required }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .sortable-ghost {
    opacity: 0.3;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/EvFormConstructor/index.vue